var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import NoteForm from "./NoteForm";
import NoteService from "../../../Services/Note.service";
import { AlertSuccess, AlertWarning, } from "../../UI/StandardAlerts/StandardAlerts";
import useUniqueId from "../../Hooks/useUniqueId";
import ShowMoreList, { StringShowMoreListRenderer, } from "../../UI/ShowMoreList/ShowMoreList";
import { MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL } from "../../Container/Pipeline/PipelineDetailListMenu";
const NoteToOpportunitiesModal = (_a) => {
    var { opportunities, pipelineId } = _a, modalProps = __rest(_a, ["opportunities", "pipelineId"]);
    const opportunityIds = opportunities.map((o) => o.id);
    const makeId = useUniqueId()[1];
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { backdrop: "static", confirmSubmit: `You are saving this note for ${opportunities.length === 1
            ? "1 opportunity"
            : opportunities.length + " opportunities"}. Are you sure you want to proceed?`, modalTitle: "New Note", keepModalOpenAfterSuccess: _jsxs(_Fragment, { children: [_jsx(AlertSuccess, { message: _jsxs(_Fragment, { children: ["Notes successfully submitted for", " ", opportunities.length === 1
                                ? "1 opportunity"
                                : opportunities.length + " opportunities", "."] }) }), _jsx(AlertWarning, { message: "Your notes are saving in the background.  This may take a few minutes to complete." })] }), handleSubmit: (state) => NoteService.saveForOpportunities({
            opportunityIds,
            pipelineId,
            noteTypeIds: state.noteTypes.map((nt) => nt.id),
            text: state.text,
        }), children: (formProps) => (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: makeId("opportunities"), children: ["Opportunities (", opportunities.length, ")"] }), _jsx("div", { id: makeId("opportunities"), children: _jsx(ShowMoreList, { numOfItemsToPreview: MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL, renderer: StringShowMoreListRenderer, items: opportunities.map((o) => o === null || o === void 0 ? void 0 : o.subject.fullName) }) })] }), _jsx(NoteForm, Object.assign({}, formProps))] })) })));
};
export default NoteToOpportunitiesModal;
